import { TFunction } from "i18next";

import { EventTypeCellParts, EventTypeStrategy } from "./EventTypeStrategy";
import { getTranslatedEventTypeName } from "../../utils/eventTypeUtils";

import { TransactionType } from "@/types/transaction/TransactionType";

export class OverspendAllowedChangedEventTypeStrategy
implements EventTypeStrategy
{
  renderCell(row: TransactionType, t: TFunction): JSX.Element {
    return (
      <>
        {t(`eventTypes.${row.eventType}`)} {t("common.to")}{" "}
        <b>
          {row.eventData.newAllowOverspend
            ? t("common.allowed")
            : t("common.notAllowed")}
        </b>
      </>
    );
  }

  getTypeAndDescription(
    row: TransactionType,
    t: TFunction
  ): EventTypeCellParts {
    const newAllowOverspend = row.eventData.newAllowOverspend;
    const previousAllowOverspend =
      newAllowOverspend !== undefined ? !newAllowOverspend : undefined;

    const parts: (string | JSX.Element)[] = [];

    if (previousAllowOverspend !== undefined) {
      parts.push(
        <>
          {t("common.previous")}:{" "}
          <b>
            {previousAllowOverspend
              ? t("common.allowed")
              : t("common.notAllowed")}
          </b>
        </>
      );
    }

    if (newAllowOverspend !== undefined) {
      if (parts.length > 0) parts.push(" | ");
      parts.push(
        <>
          {t("common.new")}:{" "}
          <b>
            {newAllowOverspend ? t("common.allowed") : t("common.notAllowed")}
          </b>
        </>
      );
    }

    return {
      type: <>{getTranslatedEventTypeName(row.eventType, t)}</>,
      description: <>{parts}</>,
    };
  }
}
